import { DropdownSelectorType } from '../types/interfaces';

export const JobsAndScoresDropdownOptions: DropdownSelectorType[] = [
  { label: 'Часы', id: 1703873957556536 },
  { label: 'Минуты', id: 170384573956534 },
  { label: 'Оценка', id: 1703873956533333 },
  { label: 'балл', id: 1703873956532232 }
];
